import type {
    HiringEventGenericOnlineLocation,
    HiringEventPhoneLocation,
    HiringEventPhysicalLocation,
    HiringEventVipLocation,
} from '../../../../../../__generated__/types.gqlgenerated';

export enum LocationTypeName {
    PHYSICAL_LOCATION_TYPE_NAME = 'HiringEventPhysicalLocation',
    GENERIC_ONLINE_LOCATION_TYPE_NAME = 'HiringEventGenericOnlineLocation',
    VIP_LOCATION_TYPE_NAME = 'HiringEventVIPLocation',
    PHONE_LOCATION_TYPE_NAME = 'HiringEventPhoneLocation',
}

export type HiringEventLocation =
    | HiringEventPhysicalLocation
    | HiringEventVipLocation
    | HiringEventPhoneLocation
    | HiringEventGenericOnlineLocation;

export type HiringEventNonPhysicalLocation = Exclude<
    HiringEventLocation,
    HiringEventPhysicalLocation
>;

export const DEFAULT_TIMEZONE = 'America/Chicago';

export const LOCALES_EXPECTING_TIMEZONES = new Set(['en-us', 'fr-ca', 'en-ca']);
